<template>
  <img src="img/Avatar.jpg" style="border-radius:50%; width: 20%; height: 20%;">
  <br><br>
  <span style="font-size: 150%">{{name}}</span>
</template>

<script>
export default {
  name: "page2Left",
  data (){
    return {
      name: "Sun Haoran",
    }
  },
}
</script>

<style scoped>
 img:hover {
  transform: scale(1.2);
  transition: all 0.6s;
  cursor: pointer;
}
</style>